import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import '@/components/icons'

Vue.use(SvgIcon, {
  tagName: 'icon',
  isOriginalDefault: true,
})
